/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Otp_DescriptionInputs */

const he_auth_otp_description = /** @type {(inputs: Auth_Otp_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שלחנו קוד בן 6 ספרות אל`)
};

const en_auth_otp_description = /** @type {(inputs: Auth_Otp_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We sent a 6-digit code to`)
};

/**
* | output |
* | --- |
* | "We sent a 6-digit code to" |
*
* @param {Auth_Otp_DescriptionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_otp_description = /** @type {((inputs?: Auth_Otp_DescriptionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Otp_DescriptionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_otp_description(inputs)
	return en_auth_otp_description(inputs)
});